import React, { FC } from "react";
import { Menu as MuiMenu, MenuProps } from "@mui/material";

const Menu: FC<MenuProps> = (props) => {
  return <MuiMenu {...props} />;
};

export default Menu;
